<template>
  <modal :show.sync="modal" @close="closeModal">
    <h4 slot="header" class="title title-up">CPF não elegível</h4>
    <div v-html="message"></div>
    <div slot="footer" class="text-center">
      <base-button type="neutral" @click="closeModal">Entendi</base-button>
    </div>
  </modal>
</template>
<script>
export default {
  name: 'customer-ineligible-modal',
  props: ['show', 'cpf', 'subscriptions'],
  emits: ['close'],
  data() {
    return {
      modal: false,
    }
  },
  watch: {
    show(newVal) {
      if (newVal) {
        this.modal = true;
      }
    },
  },
  computed: {
    message() {
      let message = `Não é possível utilizar este CPF ${this.cpf} com este plano.`;
      if (this.subscriptions && Object.keys(this.subscriptions).length > 0) {
        message += ' Este CPF já participa ou participou das seguintes assinaturas:';
        message += '<ul>';
        Object.entries(this.subscriptions).forEach(([id, status]) => {
          let statusText = '';
          switch (status) {
            case 'CANCELED': statusText = 'Cancelada'; break;
            case 'OK': statusText = 'Ativa'; break;
            case 'BLOCKED': statusText = 'Bloqueada'; break;
            case 'OUT_OF_DATE': statusText = 'Fora de Vigência'; break;
            case 'REQUESTED_CARD': statusText = 'Cartão Solicitado'; break;
            case 'CANCELLATION_REQUESTED': statusText = 'Cancelamento solicitado'; break;
            default: statusText = status;
          }
          message += `<li><a href="/assinatura/${id}" target="_blank">${id}</a> - ${statusText}</li>`;
        });
        message += '</ul>';
      }

      return message;
    },
  },
  methods: {
    closeModal() {
      this.modal = false;
      this.$emit('close');
    }
  },
}
</script>